// Mirrors backend services/password_policy.py PLATFORM_FLOORS (breach check is server-side).
export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_RULES = [
  {
    id: 'length',
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    error: `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`,
    test: (p) => p.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: 'lowercase',
    label: 'A lowercase letter',
    error: 'Password must contain a lowercase letter.',
    test: (p) => /[a-z]/.test(p),
  },
  {
    id: 'number',
    label: 'A number',
    error: 'Password must contain a number.',
    test: (p) => /\d/.test(p),
  },
];

export const passwordRuleError = (p) =>
  PASSWORD_RULES.find((r) => !r.test(p || ''))?.error || null;

export const passwordMeetsRules = (p) => passwordRuleError(p) === null;
